import React from "react";

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
  
const PontosFortesAIO = ({ flag, criticidade }) => {
      
    return (
        <>
            {(flag.ACOES || flag.AUTOMACAO || flag.MERCADOS) &&
                <Box sx={{ width: '100%', maxWidth: 600, bgcolor: 'background.paper' }} className="m-auto">
                    <Box sx={{ my: 3, mx: 2 }}>
                        <Grid container alignItems="center">
                            <Grid item xs>
                                <Typography gutterBottom variant="h4" component="div">
                                    Ações de Inovação Organizacional
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider variant="middle" />

                    <Box sx={{ m: 2 }}>
                        {flag.ACOES &&
                            <Paper className="m-2 p-3">
                            {criticidade.ACOES}
                            </Paper>
                        }
                        {flag.AUTOMACAO &&
                            <Paper className="m-2 p-3">
                            {criticidade.AUTOMACAO}
                            </Paper>
                        }
                        {flag.MERCADOS &&
                            <Paper className="m-2 p-3">
                               {criticidade.MERCADOS}
                            </Paper>
                        }
                    </Box>
                </Box>
            }
        </>
    );
};

export default PontosFortesAIO;